"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const silo_pos_types_1 = require("./silo-pos.types");
const initialState = {
    errorCode: 0,
    isError: false,
    deviceData: [],
    isLoading: false,
    errorMessage: '',
    checkpointChild: [],
    hasSelectedAPos: false,
    transactionDataSilo: [],
    countDataTransaction: 0,
    configurationCheckPointData: {
        id: '',
        type: '',
        brand1_id: '',
        brand2_id: '',
        brand3_id: '',
        brand4_id: '',
        brand5_id: '',
        brand1_name: '',
        brand2_name: '',
        brand3_name: '',
        brand4_name: '',
        brand5_name: '',
        brand1_color: '',
        brand2_color: '',
        brand3_color: '',
        brand4_color: '',
        brand5_color: '',
        dumping_type: '',
        checkpoint_id: '',
        checkpoint_name: '',
        dumping_type_id: '',
    }
};
const siloPosReducer = (0, toolkit_1.createReducer)(initialState, {
    [silo_pos_types_1.siloPosTypes.GET_LANDING_PAGE_DATA_SILO]: (state, action) => {
        const { DeviceData, TransactionDataSilo, countDataTransaction, ConfigurationCheckPointData, } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, hasSelectedAPos: true, deviceData: DeviceData, transactionDataSilo: TransactionDataSilo, countDataTransaction: countDataTransaction, configurationCheckPointData: ConfigurationCheckPointData });
    },
    [silo_pos_types_1.siloPosTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false });
    },
    [silo_pos_types_1.siloPosTypes.RESET_SELECTED_POS]: (state, action) => {
        return Object.assign(Object.assign({}, state), { hasSelectedAPos: action.payload.hasSelectedAPos });
    },
    [silo_pos_types_1.siloPosTypes.SET_SELECTED_CHECKPOINT]: (state, action) => {
        return Object.assign(Object.assign({}, state), { checkpointChild: action.payload.checkpointChild });
    }
});
exports.default = siloPosReducer;
